/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Soft_Tissue_Therapy_TermsInputs */

const en_service_type_soft_tissue_therapy_terms = /** @type {(inputs: Service_Type_Soft_Tissue_Therapy_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`myofascial, fascia, trigger points, muscle tension`)
};

const pl_service_type_soft_tissue_therapy_terms = /** @type {(inputs: Service_Type_Soft_Tissue_Therapy_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`powięź, terapia powięziowa, punkty spustowe, rozluźnianie mięśni, napięcie mięśni`)
};

/**
* | output |
* | --- |
* | "myofascial, fascia, trigger points, muscle tension" |
*
* @param {Service_Type_Soft_Tissue_Therapy_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_soft_tissue_therapy_terms = /** @type {((inputs?: Service_Type_Soft_Tissue_Therapy_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Soft_Tissue_Therapy_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_soft_tissue_therapy_terms(inputs)
	return en_service_type_soft_tissue_therapy_terms(inputs)
});